// Disabled fields keep their settings in the dashboard but are not part of the
// page. They sit above hidden fields and conditional logic: nothing can reveal,
// prefill or submit them.
export function isFieldDisabled(field) {
  return field?.disabled === true;
}

export default function getEnabledFields(fields) {
  if (!Array.isArray(fields)) return fields;

  return fields.filter(field => !isFieldDisabled(field));
}
